import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, ViewEncapsulation, computed, inject } from '@angular/core';
import type { Icon } from '@hyundai/assets';
import {
    AnchorDirective,
    BusinessCustomerFeature,
    DealerFeature,
    RouterLinkDirective,
    TrackingDirective,
} from '@hyundai/ng-common-lib';
import { EditableDirective } from '@hyundai/ng-edit-lib';
import {
    M000C010ImageComponent,
    M010C020IconLinkComponent,
    M030C130WarrentyListComponent,
    M040C020TeaserAllrounderComponent,
    M040C040PromotionBannerComponent,
    M040C050CardComponent,
    M040C070ContactPersonComponent,
} from '@hyundai/ui';
import { Store } from '@ngrx/store';
import { GlobalContactComponent } from '../../components/global-contact/global-contact.component';

@Component({
    selector: 'app-business-customer-page',
    standalone: true,
    imports: [
        AnchorDirective,
        RouterLinkDirective,
        M000C010ImageComponent,
        M010C020IconLinkComponent,
        GlobalContactComponent,
        M030C130WarrentyListComponent,
        M040C020TeaserAllrounderComponent,
        M040C040PromotionBannerComponent,
        M040C050CardComponent,
        M040C070ContactPersonComponent,
        EditableDirective,
        NgClass,
        TrackingDirective,
    ],
    templateUrl: './business-customer-page.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BusinessCustomerPageComponent {
    store = inject(Store);
    dealer = this.store.selectSignal(DealerFeature.state.selectLoadedDealer);
    dealerContactMailLink = this.store.selectSignal(DealerFeature.state.selectDealerContactFormUrl);
    locationHeadline = this.store.selectSignal(DealerFeature.state.selectDealerLocationHeadline);
    content = this.store.selectSignal(BusinessCustomerFeature.state.selectLoadedContent);
    keyCampaign = this.store.selectSignal(DealerFeature.state.selectKeyCampaign);
    businessCustomerHighlights = this.store.selectSignal(
        BusinessCustomerFeature.state.selectBuisnessCustomerHighlights,
    );
    warrantyList = this.store.selectSignal(BusinessCustomerFeature.state.selectWarrantyList);

    heroBullets = computed(() => {
        const content = this.content();

        if (!content) return;

        const heroBulletList: Array<{ icon: Icon; text: string }> = content.heroBulletList.map((b) => ({
            icon: 'icon-check',
            text: b.text,
        }));
        return heroBulletList;
    });
}
